module.exports = __webpack_public_path__ + "static/final.d5482731.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/authentication/final.png
// module id = 194
// module chunks = 183865321790273 233530150144089